import React from 'react';
import { useGetCompalinWebQuery } from './CompalinWebSlice';
import { useNavigate } from 'react-router-dom';
import AddCompalinWeb from './AddCompalinWeb';

const CompalinWeb = () => {
    const navigate = useNavigate();

    const {
        data: compalinWeb
    } = useGetCompalinWebQuery('getCompalinWeb');

    return (
        <>
            <div className='container-fluid'>
                <div className="d-flex justify-content-end mt-5 ml-4 mb-2">
                    <div className="text-right">
                        <AddCompalinWeb/>
                    </div>
                </div>
                <div>
                    <div className='box_overflow col'>
                        <table className='border table p-2'>
                            <thead className='mobile-hidden'>
                                <tr className='bg-left-navabr '>
                                    <th className='text-light'>#</th>
                                    <th className='text-light'>Name</th>
                                    <th className='text-light'>Number</th>
                                    <th className='text-light'>Property Name</th>
                                    <th className='text-light'>Street</th>
                                    <th className='text-light'>Address</th>
                                </tr>
                            </thead>
                            <tbody className='mobile-hidden'>
                                {compalinWeb?.map((e, index) => (
                                    <tr key={e?.c_id}
                                        onClick={() => (navigate(`/b2g/CompalinWebDetail/${e?.c_id}`))}
                                    >
                                        <td>{index + 1}</td>
                                        <td>{e?.name}</td>
                                        <td>{e?.number}</td>
                                        <td>{e?.property_name}</td>
                                        <td>{e?.street}</td>
                                        <td>{e?.full_address}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>

            </div>
        </>
    );
}

export default CompalinWeb;
